import React from 'react';
import { ButtonColors, ButtonSizes, SecondaryButton } from 'src/shared/design-system/Buttons';
import { CaretIcon } from 'src/shared/design-system/CaretIcon';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { Colors } from 'web-common/src/shared/styles';

interface IProps {
  onClick: () => void;
  name?: string;
  selected: boolean;
  showCaret?: boolean;
  className?: string;
}

const FilterButtonBase = styled(SecondaryButton)<{ selected: boolean }>`
  color: ${Colors.GRAY_DARK_30};
  font-size: 14px;
  font-weight: normal;

  ${ifProp(
    'selected',
    css`
      color: ${Colors.WHITE};
      background-color: ${Colors.GRAY_DARK_30};
      ${CaretIcon} {
        path {
          fill: ${Colors.WHITE};
        }
      }
      :hover {
        color: ${Colors.GRAY_DARK_30};
        ${CaretIcon} {
          path {
            fill: ${Colors.GRAY_DARK_30};
          }
        }
      }
    `
  )}
`;

export const FilterButton: React.FC<React.PropsWithChildren<IProps>> = ({
  onClick,
  name,
  selected,
  children,
  showCaret,
  className,
}) => (
  <FilterButtonBase
    onClick={onClick}
    name={name}
    selected={selected}
    size={ButtonSizes.S}
    className={className}
    color={ButtonColors.LIGHT_GRAY}>
    {children}
    {showCaret && <CaretIcon />}
  </FilterButtonBase>
);
